import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index2.js';
import { C as CURRENCY_MASK } from './form-input-masks.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const MonetaryInput = /*@__PURE__*/ proxyCustomElement(class MonetaryInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, this.maskOptions);
            this.imask.on('accept', () => {
                const rawValue = this.imask.unmaskedValue;
                this.inputHandler(this.name, rawValue);
                this.formControlInput.emit({ name: this.name, value: rawValue });
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            const rawValue = this.imask.unmaskedValue;
            this.formControlInput.emit({ name: name, value: rawValue });
        };
        this.updateInput = (newValue) => {
            if (this.imask) {
                this.imask.value = String(newValue);
            }
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.maskOptions = CURRENCY_MASK.DECIMAL;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.initializeIMask();
        this.updateInput(this.defaultValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        return (h(Host, { key: '2a65acfea8e79d22dd09c7c116d80b12a2f2a47c', exportparts: "label,input,input-group-input,input-group-text,input-invalid" }, h("div", { key: '166dfb5c261c21d58db1a0e17d8bae149834c149', class: "form-group d-flex flex-column" }, h("label", { key: '1980871936440222e2b711ba2953d7b6287bf080', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("div", { key: '4cfb60bf946fa7e745c93b391997218122c551a0', class: "input-group" }, h("span", { key: '711357a32f9dc1fef77359f15ec3167a468d0463', class: "input-group-text", part: "input-group-text" }, "$"), h("input", { key: '2489cab2ecb61096f781d339363dad50404e3c67', ref: el => (this.textInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input input-group-input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control monetary is-invalid' : 'form-control monetary', type: "text", disabled: this.disabled })), h("form-control-help-text", { key: 'f7e89f0830ca0f453b02595303a245691f448d55', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '61f03f0d09027237ab3f5c7979981ddc3dc4c916', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-monetary", {
        "label": [1],
        "name": [1],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16],
        "maskOptions": [8, "mask-options"],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-monetary", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-monetary":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MonetaryInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MonetaryInput as M, defineCustomElement as d };
